module.exports = __webpack_public_path__ + "img/MIO_TC.d6bdc169.jpg";